import { ReactElement, useRef, useState } from 'react';
import onPreviewLoadError from '../../utils/on-preview-load-error';
import cn from '../../utils/classnames';
import Spinner from '../../ui/spinner/spinner';
import { SPINNER_SIZES } from '../../ui/spinner/spinner.constants';
import useIsImageVisible from './hooks/use-is-image-visible';
import './lazy-loaded-image.scss';

type LazyLoadedImageProps = {
    src: string;
    alt?: string;
    onClick?: VoidFunction;
    className?: string;
    wrapperClassName?: string;
};

const LazyLoadedImage = (props: LazyLoadedImageProps): ReactElement => {
    const { src, alt, onClick, className, wrapperClassName } = props;

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const imageWrapperRef = useRef<HTMLDivElement | null>(null);

    const shouldStartLoading = useIsImageVisible({ imageWrapperRef });
    const shouldShowSpinner = shouldStartLoading && !isLoaded;

    const handleLoad = (): void => setIsLoaded(true);

    return (
        <div className={cn('lazy-loaded-image-wrapper', wrapperClassName)} ref={imageWrapperRef}>
            {shouldShowSpinner && <Spinner size={SPINNER_SIZES.SMALL} />}

            {shouldStartLoading && (
                <img
                    className={cn('lazy-loaded-image', className)}
                    src={src}
                    alt={alt}
                    role='presentation'
                    onClick={onClick}
                    onLoad={handleLoad}
                    onError={(e): void => onPreviewLoadError(e, '')}
                />
            )}
        </div>
    );
};

export default LazyLoadedImage;
